import { AppMessage } from '@/common/components';
import { FC, memo, useCallback } from 'react';
import { useQueryClient } from 'react-query';
import { useNavigate } from 'react-router';

import { AppRoutes } from '@/common/interfaces';
import { FallbackedLayout } from '@/common/layouts';
import { messageOnError } from '@/common/utils';

import { PageLayoutsQueryKeys, useDeleteLayoutsPageMutation, useGetByIdLayoutsPageQuery } from '@/modules/Pages';

import { PageLayoutsViewView } from './PageLayoutsViewView';

interface Props {
  siteId: string;
  layoutId: string;
}

export const PageLayoutsViewContainer: FC<Props> = memo(({ siteId, layoutId }) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const appMessageApi = AppMessage.useControls();

  const { data, isLoading, error, isError } = useGetByIdLayoutsPageQuery(layoutId, siteId)();

  const { mutate: deleteLayoutMutation, isLoading: isDeleteLayoutLoading } = useDeleteLayoutsPageMutation(layoutId, siteId)({
    onSuccess: async () => {
      appMessageApi.success('Макет сторінки успішно видалено!');

      await queryClient.refetchQueries([PageLayoutsQueryKeys.GetAll, siteId]);

      navigate(AppRoutes.SitesTemplates.replace(':siteId', siteId));
    },
    onError: (err) => {
      messageOnError(err, appMessageApi);
    }
  });

  const handleDeleteLayout = useCallback(() => {
    deleteLayoutMutation();
  }, []);

  return (
    <FallbackedLayout
      isLoading={ isLoading }
      error={ error }
      isError={ isError }
      data={ data }
    >
      {
        (layout) => (
          <PageLayoutsViewView
            layout={ layout }
            isDeleteLayoutLoading={ isDeleteLayoutLoading }
            disableControlButtons={ isLoading }
            handleDeleteLayout={ handleDeleteLayout }
          />
        )
      }
    </FallbackedLayout>
  );
});
